import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css, useTheme } from "styled-components";
import { Spinner } from "~/components-shared";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.div`
  position: relative;
  display: ${_ref => {
  let {
    $display
  } = _ref;
  return $display;
}};
  align-items: center;
  justify-content: center;
  width: ${_ref2 => {
  let {
    $width
  } = _ref2;
  return $width;
}};
  opacity: ${_ref3 => {
  let {
    $opacity
  } = _ref3;
  return $opacity;
}};
  min-width: ${_ref4 => {
  let {
    $width
  } = _ref4;
  return $width;
}};
  max-width: ${_ref5 => {
  let {
    $width
  } = _ref5;
  return $width;
}};
  font-size: ${_ref6 => {
  let {
    $width
  } = _ref6;
  return `calc(${$width} / 3)`;
}};
  font-weight: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.typography.fontWeight.bold;
}};
  line-height: 0.66rem;
  height: ${_ref8 => {
  let {
    $height
  } = _ref8;
  return $height;
}};
  ${_ref9 => {
  let {
    $src
  } = _ref9;
  return !!$src && css`
      background-image: url("${$src}");
    `;
}};
  background-size: ${_ref10 => {
  let {
    $backgroundSize
  } = _ref10;
  return $backgroundSize;
}};
  background-repeat: no-repeat;
  background-position: center;
  ${_ref11 => {
  let {
    $border,
    theme
  } = _ref11;
  return $border === "rounded" && `border-radius: ${theme.shape.borderRadius.primary}`;
}};
  ${_ref12 => {
  let {
    $border
  } = _ref12;
  return $border === "circled" && `border-radius: 50%`;
}};
  background-color: ${_ref13 => {
  let {
    theme,
    $color,
    $src
  } = _ref13;
  return $src ? "transparent" : genericColor(theme, $color);
}};
  text-align: center;
  ${_ref14 => {
  let {
    $s,
    theme
  } = _ref14;
  return theme.spacing.resolve(theme, $s);
}};

  ${_ref15 => {
  let {
    $src,
    $name,
    theme
  } = _ref15;
  return !$src && css`
      &:after {
        content: "${$name[0]}";
        text-transform: uppercase;
        font-size: 1.5em;
        line-height: 1.5em;
        color: ${theme.colors.primary.text};
        font-weight: ${theme.typography.fontWeight.bold};
      }
    `;
}}

  ${_ref16 => {
  let {
    $shadow,
    $border,
    theme
  } = _ref16;
  return $shadow && css`
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 200ms ease-out;
        ${$border === "rounded" && `border-radius: ${theme.shape.borderRadius.primary}`};
        ${$border === "circled" && `border-radius: 50%`};
        box-shadow: ${theme.shadows.large};
      }
    `;
}}
`;
const Picture = _ref17 => {
  let {
    src,
    name = "",
    width = "120px",
    height = "120px",
    loading = false,
    shadow = false,
    opacity = 1,
    border = "rounded",
    backgroundSize = "cover",
    color = "secondary",
    display = "flex",
    s,
    ...rest
  } = _ref17;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $src: src,
    $shadow: shadow,
    $name: name,
    $opacity: opacity,
    $s: s,
    $width: width,
    $backgroundSize: backgroundSize,
    $height: height,
    $color: color,
    $display: display,
    $border: border
  }, rest), loading && /*#__PURE__*/React.createElement(Spinner, {
    color: theme.colors.background.primary
  }));
};
export default Picture;